import { InstitutionDetail } from "../../models/institutionDetail.model";
import { Action } from "@ngrx/store";

export const GET_INSTITUTION_CURRENT = '[Institution] Get Current Institution';
export const GET_INSTITUTION_CURRENT_SUCCESS = '[Institution] Get Current Institution Success';
export const GET_INSTITUTION_CURRENT_FAIL = '[Institution] Get Current Institution Fail';
export const CLEAR_INSTITUTION_CURRENT = '[Insitution] Clear Current Institution';

export class GetInstitutionCurrent implements Action {
    readonly type = GET_INSTITUTION_CURRENT;
    constructor(
      public payload: {id?: number, name: string} = null,
    ) {}
  }

  export class GetInstitutionCurrentSuccess implements Action {
    readonly type = GET_INSTITUTION_CURRENT_SUCCESS;
    constructor(public payload: any = null) {}
  }

  export class GetInstitutionCurrentFail implements Action {
    readonly type = GET_INSTITUTION_CURRENT_FAIL;
    constructor(public payload: any = null) {}
  }

  export class ClearInstitutionCurrent implements Action {
    readonly type = CLEAR_INSTITUTION_CURRENT;
    constructor(){}
  }

  export type InstitutionActions =
  | GetInstitutionCurrent
  | GetInstitutionCurrentSuccess
  | GetInstitutionCurrentFail
  | ClearInstitutionCurrent;
